// One card plays at a time, with sound.
//
// Sound is the point: these are people talking, and a muted testimonial is a
// stock photo. So a tap unmutes and every other card stops — two voices at once
// is worse than none.
(function () {
  if (window.__pruvitStoryRail) return;
  window.__pruvitStoryRail = true;

  function stopAll(rail) {
    rail.querySelectorAll('[data-pruvit-vcard]').forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.pause();
      video.muted = true;
      card.classList.remove('is-playing');
    });
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-pruvit-vcard]');
    if (!card) return;

    var rail = card.closest('[data-pruvit-vrail]');
    var video = card.querySelector('video');
    if (!rail || !video) return;

    var wasPlaying = !video.paused;
    stopAll(rail);
    if (wasPlaying) return; // a second tap on the playing card is "stop"

    video.muted = false;
    card.classList.add('is-playing');
    // A refused play leaves the card marked as playing and silent, which reads
    // as broken; drop the mark and let the still stand.
    var started = video.play();
    if (started && typeof started.catch === 'function') {
      started.catch(function () {
        card.classList.remove('is-playing');
      });
    }
  });

  document.addEventListener(
    'ended',
    function (event) {
      var card = event.target.closest('[data-pruvit-vcard]');
      if (card) card.classList.remove('is-playing');
    },
    true // 'ended' does not bubble
  );
})();
